const initialState = {
  purchase: { content: "ChoosePlan", step: "SelectPlan" },
  planInfo: {
    periodicity: "",
    paymentMethod: "",
    orderStatusPix: "",
    pixIsPaid: false,
    value: "",
    content: "",
    step: "",
  },
  PostData: {
    sub: null,
    cupom_code: null,
    periodicity: null,
    currency: 1,
    product_id: null,
    payment_method: null,
    invoice_info: {
      zipCode: "",
      document: "",
      name: "",
      phone: "",
      street: "",
      number: "",
      complement: "",
      city: "",
      state: "",
      country: "",
      neighborhood: "",
      email: "",
      profile: "",
    },
    email: null,
  },
  LastPayment: {
    paymentMethod: null,
    periodicity: null,
    nextCharge: null,
  },
};

const _PurchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PURCHASE": {
      // Atualizar subestados apenas se necessário
      const newPurchase = action.purchase
        ? { ...state.purchase, ...action.purchase }
        : state.purchase;

      const newPlanInfo = action.planInfo
        ? { ...state.planInfo, ...action.planInfo }
        : state.planInfo;

      const newPostData = action.PostData
        ? { ...state.PostData, ...action.PostData }
        : state.PostData;

      const newLastPayment = action.LastPayment
        ? { ...state.LastPayment, ...action.LastPayment }
        : state.LastPayment;

      // Comparar subestados
      const hasChanges =
        JSON.stringify(newPurchase) !== JSON.stringify(state.purchase) ||
        JSON.stringify(newPlanInfo) !== JSON.stringify(state.planInfo) ||
        JSON.stringify(newPostData) !== JSON.stringify(state.PostData) ||
        JSON.stringify(newLastPayment) !== JSON.stringify(state.LastPayment);

      if (!hasChanges) {
        //console.log("Nenhuma mudança detectada, estado preservado.");
        return state; // Sem mudanças, retorna o mesmo estado
      }

      //console.log("Mudança detectada, atualizando estado.");
      return {
        ...state,
        purchase: newPurchase,
        planInfo: newPlanInfo,
        PostData: newPostData,
        LastPayment: newLastPayment,
      };
    }

    case "RESET_PURCHASE":
      //console.log("Resetando estado para o inicial.");
      return initialState;

    default:
      return state;
  }
};

export default _PurchaseReducer;